'use client';

import { Container } from '..';
import { H1_OPT } from './styleConstants';
import { TestCard } from './TestCard';
import { useEffect, useState } from 'react';
import styles from './BloodTestSection.module.css';

export interface BloodTestPackage {
  title: string;
  gender_tags?: Array<{ text: string; color: string }>;
  is_recommended?: boolean;
  subtitle?: string;
  description?: string;
  instruction_bullets?: Array<{ title: string; icon: string; color: string }>;
  price_text?: string;
  amount?: number;
  [key: string]: any;
}

export interface BloodTestCategory {
  title: string;
  packages: BloodTestPackage[];
}

export const BloodTestSection = ({
  initialTests = [],
  className,
}: {
  initialTests?: BloodTestCategory[];
  className?: string;
}) => {
  const [tests] = useState<BloodTestCategory[]>(initialTests);
  const [activePackage, setActivePackage] = useState(
    initialTests[0]?.title ?? '',
  );
  const [packageContent, setPackageContent] = useState<BloodTestPackage[]>(
    initialTests[0]?.packages ?? [],
  );

  useEffect(() => {
    const activePackageData = tests.find(
      (test) => test?.title === activePackage,
    );
    if (activePackageData?.packages) {
      setPackageContent(activePackageData.packages);
    }
  }, [activePackage, tests]);

  const onTabClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const title = (e.currentTarget as HTMLButtonElement).id;
    if (title) {
      setActivePackage(title);
    }
  };

  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <div className={styles.mainContent}>
          <H1_OPT>All Blood Tests</H1_OPT>
          <div className={`${styles.tabs} u-hide-scrollbar`}>
            {tests.map((param, idx) => {
              return (
                <button
                  className={styles.tab}
                  id={param?.title}
                  key={idx}
                  onClick={onTabClick}
                  style={{
                    color:
                      activePackage === param?.title ? '#000000' : '#00000066',
                    borderBottom:
                      activePackage === param?.title
                        ? '1px solid #000000'
                        : 'none',
                  }}
                >
                  {param?.title}
                </button>
              );
            })}
          </div>
          <div className={styles.testCards}>
            {packageContent.map((pack, idx) => {
              return <TestCard packageData={pack} key={idx} />;
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};
